import { createContext } from 'react';

import { ZoomRanges } from '../../core/types/interactions.js';
import type { TimeseriesZoomDomain } from '../types/timeseries.js';

export const TimeseriesZoomRangesContext = createContext<
  ZoomRanges<TimeseriesZoomDomain>
>({});

TimeseriesZoomRangesContext['displayName'] = 'TimeseriesZoomRangesContext';
